export const environment = {
    production: true,
    apiUrl: 'https://ops-api.info'
  };